import React from 'react'

function Header() {
  return (
    <div style={{width: '100%', textAlign: 'center', backgroundColor: '#010101'}}>
        <h1 className='navheadin'>Get you Zip code details</h1>
    </div>
  )
}

export default Header